jQuery(function($) {
  $(".accubanker-slick").slick({
    dots: false,
    arrows: true,
    infinite: true,
    autoplay: true,
  	autoplaySpeed: 5000,
    prevArrow:"<button type='button' class='slick-prev pull-left'><i class='arrow left'></i></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><i class='arrow right'></i></button>"
  });
  $(".flexible-grid-items").slick({
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
  	autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 2000,
        settings: 'unslick'
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  $('.image-slider-block').show();
  
  openExternalNewTab();
  
  if(jQuery('#defaultOpen').length > 0) {
    // Get the element with id="defaultOpen" and click on it
    document.getElementById("defaultOpen").click();
  }
  
  // Custom Jquery to dynamically render logo
  
  var pageURL = $(location).attr("href");
  
if(pageURL === "https://www.accubanker.com/pages/silver") {
    $("#shopify-section-header > sticky-header > header > h1 > a > img").attr('srcset','https://cdn.shopify.com/s/files/1/1256/9911/files/silverLogo256x35_256x256_crop_center.png?v=1646338810' )
      $("#shopify-section-footer > footer > section > div > div.footer__content-top > div > div.footer-logo.footer-block.grid__item > div > a > img").attr('srcset','https://cdn.shopify.com/s/files/1/1256/9911/files/silverLogo256x35_256x256_crop_center.png?v=1646338810' )
 }
 if(pageURL === "https://www.accubanker.com/collections/silver-bill-counters") {
    $("#shopify-section-header > sticky-header > header > h1 > a > img").attr('srcset','https://cdn.shopify.com/s/files/1/1256/9911/files/silverLogo256x35_256x256_crop_center.png?v=1646338810' )
      $("#shopify-section-footer > footer > section > div > div.footer__content-top > div > div.footer-logo.footer-block.grid__item > div > a > img").attr('srcset','https://cdn.shopify.com/s/files/1/1256/9911/files/silverLogo256x35_256x256_crop_center.png?v=1646338810' )
 }
 if(pageURL === "https://www.accubanker.com/products/s6500-mixed-bill-counter-with-counterfeit-detection") {
    $("#shopify-section-header > sticky-header > header > h1 > a > img").attr('srcset','https://cdn.shopify.com/s/files/1/1256/9911/files/silverLogo256x35_256x256_crop_center.png?v=1646338810' )
    $("#shopify-section-footer > footer > section > div > div.footer__content-top > div > div.footer-logo.footer-block.grid__item > div > a > img").attr('srcset','https://cdn.shopify.com/s/files/1/1256/9911/files/silverLogo256x35_256x256_crop_center.png?v=1646338810' )
 }
 if(pageURL === "https://www.accubanker.com/products/s3500-flex-bill-counter-with-counterfeit-detection") {
    $("#shopify-section-header > sticky-header > header > h1 > a > img").attr('srcset','https://cdn.shopify.com/s/files/1/1256/9911/files/silverLogo256x35_256x256_crop_center.png?v=1646338810' )
      $("#shopify-section-footer > footer > section > div > div.footer__content-top > div > div.footer-logo.footer-block.grid__item > div > a > img").attr('srcset','https://cdn.shopify.com/s/files/1/1256/9911/files/silverLogo256x35_256x256_crop_center.png?v=1646338810' )
 }
 if(pageURL === "https://www.accubanker.com/products/s1070-bill-counter-with-external-portable-battery-optional") {
    $("#shopify-section-header > sticky-header > header > h1 > a > img").attr('srcset','https://cdn.shopify.com/s/files/1/1256/9911/files/silverLogo256x35_256x256_crop_center.png?v=1646338810' )
    $("#shopify-section-footer > footer > section > div > div.footer__content-top > div > div.footer-logo.footer-block.grid__item > div > a > img").attr('srcset','https://cdn.shopify.com/s/files/1/1256/9911/files/silverLogo256x35_256x256_crop_center.png?v=1646338810' )
 }
 if(pageURL === "https://www.accubanker.com/collections/silver-pos-equipment") {
    $("#shopify-section-header > sticky-header > header > h1 > a > img").attr('srcset','https://cdn.shopify.com/s/files/1/1256/9911/files/silverLogo256x35_256x256_crop_center.png?v=1646338810' )
    $("#shopify-section-footer > footer > section > div > div.footer__content-top > div > div.footer-logo.footer-block.grid__item > div > a > img").attr('srcset','https://cdn.shopify.com/s/files/1/1256/9911/files/silverLogo256x35_256x256_crop_center.png?v=1646338810' )
 }
 if(pageURL === "https://www.accubanker.com/products/pos-kit-bundle") {
    $("#shopify-section-header > sticky-header > header > h1 > a > img").attr('srcset','https://cdn.shopify.com/s/files/1/1256/9911/files/silverLogo256x35_256x256_crop_center.png?v=1646338810' )
    $("#shopify-section-footer > footer > section > div > div.footer__content-top > div > div.footer-logo.footer-block.grid__item > div > a > img").attr('srcset','https://cdn.shopify.com/s/files/1/1256/9911/files/silverLogo256x35_256x256_crop_center.png?v=1646338810' )
 }
 if(pageURL === "https://www.accubanker.com/products/scd10-silk-cash-drawer") {
    $("#shopify-section-header > sticky-header > header > h1 > a > img").attr('srcset','https://cdn.shopify.com/s/files/1/1256/9911/files/silverLogo256x35_256x256_crop_center.png?v=1646338810' )
    $("#shopify-section-footer > footer > section > div > div.footer__content-top > div > div.footer-logo.footer-block.grid__item > div > a > img").attr('srcset','https://cdn.shopify.com/s/files/1/1256/9911/files/silverLogo256x35_256x256_crop_center.png?v=1646338810' )
 }
 if(pageURL === "https://www.accubanker.com/products/ipad-pos-stand-w-rotary-plate") {
    $("#shopify-section-header > sticky-header > header > h1 > a > img").attr('srcset','https://cdn.shopify.com/s/files/1/1256/9911/files/silverLogo256x35_256x256_crop_center.png?v=1646338810' )
    $("#shopify-section-footer > footer > section > div > div.footer__content-top > div > div.footer-logo.footer-block.grid__item > div > a > img").attr('srcset','https://cdn.shopify.com/s/files/1/1256/9911/files/silverLogo256x35_256x256_crop_center.png?v=1646338810' )
 }
 
  
  
  
 console.log("I'm working!", pageURL)
});

function openTab(tabName,elmnt) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablink");
  document.getElementById(tabName).style.display = "block";
  tablinks.classList.remove("active");
  elmnt.classList.add("active");
}

function openExternalNewTab() {
	var links = document.links;
    for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
      if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
      }
    }
}